import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { hooks } from "../../../hooks";
import { FlexColumn } from "../Styles";
import EmojiPickerProps from "./EmojiPicker";
import GIFList from "./GIFList";

export const EmojiPicker = ({
  setShowEmojiOptions,
  onGifSelected = () => {},
  children,
  showEmojiOptions,
  scrollAreaId,
}: EmojiPickerProps.IProps) => {
  const emojiOptionsRef = useRef<HTMLDivElement>(null);
  const childrenRef = useRef<HTMLDivElement>(null);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const dropdownRect = childrenRef?.current?.getBoundingClientRect();
  const top = dropdownRect?.top ?? 0;
  const bottom = dropdownRect?.bottom ?? 0;
  const right = dropdownRect?.right ?? 0;

  const tabContent = {
    0: (
      <GIFList
        onGifSelected={onGifSelected}
        searchValue={debouncedSearchValue}
      />
    ),
    1: <></>,
  };

  const scroll = hooks.useScroll(scrollAreaId);
  const dimension = hooks.useBodySize();

  hooks.useClickOutside({
    ref: emojiOptionsRef,
    setState: setShowEmojiOptions,
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchValue]);

  useEffect(() => {
    setSearchValue("");
  }, [selectedTabIndex]);

  useEffect(() => {
    setShowEmojiOptions(false);
  }, [scroll, setShowEmojiOptions, dimension]);

  return (
    <div>
      <div ref={childrenRef}>{children}</div>
      {showEmojiOptions && (
        <Container
          ref={emojiOptionsRef}
          $left={
            right - 342 > 0 ? right - 342 : right - (dropdownRect?.width ?? 0)
          }
          $top={top - 396 > 0 ? top - 396 : bottom + 8}
        >
          <Components.Menu size="fill" withBackground={true} itemGap={8}>
            <Inputs.Input
              fieldName="search-emoji"
              idPrefix="comment"
              isRequired={false}
              onChangeHandler={(value) => {
                setSearchValue(value);
              }}
              value={searchValue}
              size="Small"
              placeholder="Search"
              iconType="Search"
            />
            <Components.Tabs
              TabItems={[
                { title: "GIF", iconType: "Gif" },
                { title: "Stickers", iconType: "Sticker" },
              ]}
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={setSelectedTabIndex}
            />
            {tabContent[selectedTabIndex as keyof typeof tabContent]}
          </Components.Menu>
        </Container>
      )}
    </div>
  );
};

const Container = styled(FlexColumn)<{
  $top: number;
  $left: number;
}>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  z-index: 4;
  width: 342px;

  .menu-container {
    padding-top: ${({ theme }) => theme.spacing["spacing-5"].value}rem;
    height: 388px;
  }
`;
